const MESSAGE = {
  LOGIN_SUCCESSFUL: "Login successful",
  UNEXPECTED_ERROR: "We encountered an error, please try again",
  LOGOUT_SUCCESSFUL: "Logout successful",
  REGISTRATION_SUCCESSFUL: "Registration successful",
  FORGOT_PASSWORD_SUCCESSFUL: "Email sent if account exists",
  RESET_PASSWORD_SUCCESSFUL: "Password reset successful, please login",
  AUTH_UNSUCCESSFUL: "Authencation unsuccessful, please login",
  ACCOUNT_VERIFICATION_SUCCESSFUL:
    "Account verification successful, please login",
  ACCOUNT_VERIFICATION_UNSUCCESSFUL:
    "Account verification was not successful, please use the correct link sent to your email",
  MISSING_FIELD: "All required fields has not been filled",
  ROOM_TEAMN_NOT_AVAILABLE: "Room's team (Admin) is not available",
  DUPLICATE_TEAM_NAMES: "We have a duplicate team name, please update",
  CHOOSE_A_ROOM_TEAM: "Please, select a room's team",
  PERMISSION: "You don't have enough permission to perform this action",
  TOOLBOX_STATUS_UPDATED: (roomName) => {
    return `The status of your toolbox in room ${roomName} has been updated`;
  },
  KICKED_OFF_CHAT: "Your account has been kicked off from chat room",
  KICKED_IN_CHAT: "Your account has been kicked into the chat room",
  NO_REMAINING_ROOM_CHATS: "You don't have any chats left",
  NO_REMAINING_ROOM_MESSAGES: "You don't have any messages left",
  ROOM_HAS_EXPIRED: "Room has now expired",
  ROOM_DELETED: "Room deleted successfully",
  ROOM_NOT_ACTIVE: "No active room found, hang on",
  ROOM_TOOLBOX_NOT_ACTIVE: "Your room's toolbox is not active",

  // Notification messages
  NOTIFICATION_MARKED_READ: "Notification marked as read",
  ALL_NOTIFICATIONS_MARKED_READ: "All notifications marked as read",
  NOTIFICATION_ERROR: "Error loading notifications",

  // Bookmark messages
  ROOM_BOOKMARKED: "Room bookmarked successfully",
  ROOM_ALREADY_BOOKMARKED: "Room already bookmarked",
  ROOM_UNBOOKMARKED: "Room unbookmarked successfully",
  BOOKMARK_ERROR: "Error updating bookmark",
};

export default MESSAGE;
